import React, { useState, useEffect, useCallback } from 'react';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import { PaymentMethod } from 'models/paymentCard';
import PaymentMethodList from 'screens/components/Payment/PaymentMethodList';
import { getPaymentMethods } from 'services/paymentMethodService';

const filterMethods = (data: PaymentMethod[], otherCard) => {
  const IMAGE_PATH = '/images/payment/cc/';
  const AVAILABLE_CC = [
    {
      id: 'american_expressr',
      image: 'amex.svg',
    },
    {
      id: 'master',
      image: 'mastercard.svg',
    },
    {
      id: 'visa',
      image: 'visa.svg',
    },
    {
      id: 'cc',
      image: 'payment.svg',
    },
  ];

  let filteredMethods = data.filter(
    (p: PaymentMethod) =>
      p.tokenizer &&
      (p.tokenizer.toUpperCase() === 'SPREEDLY' || p.tokenizer.toUpperCase() === 'VGS') &&
      typeof AVAILABLE_CC.find((cc) => cc.id.toUpperCase() === p.id.toUpperCase()) !== 'undefined',
  );
  filteredMethods = filteredMethods.map((p: PaymentMethod) => {
    const cc = AVAILABLE_CC.find((cc) => cc.id.toUpperCase() === p.id.toUpperCase());
    return {
      ...p,
      main_icon: `${IMAGE_PATH}${cc?.image}`,
      description: p.id === 'cc' ? otherCard : p.description,
    } as PaymentMethod;
  });
  return filteredMethods;
};
interface Params {
  match: {
    params: {
      groupId?: string;
    };
  };
  originGroup?: string;
  onCloseModal?: () => void;
  onAdded?: (cardId?: number) => void;
}

const PaymentAddMethodContainer = ({ match: { params }, originGroup, onCloseModal, onAdded }: Params) => {
  const [isLoading, setIsLoading] = useState(!!params.groupId);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const [list, setList] = useState<PaymentMethod[]>();

  const handleGetData = useCallback(async () => {
    setIsLoading(true);

    try {
      const data = await getPaymentMethods();
      setIsLoading(false);
      const filteredMethods = filterMethods(data, t('payment.paymentMethods.otherCC'));
      setList(filteredMethods);
    } catch (error) {
      toast.add({
        type: 'danger',
        message: error.message,
      });
      setIsLoading(false);
    }
  }, [toast, t]);

  useEffect(() => {
    handleGetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PaymentMethodList
      groupTarget={originGroup}
      groupId={params.groupId}
      isLoading={isLoading}
      list={list}
      onCloseModal={onCloseModal}
      onAdded={onAdded}
    />
  );
};

export default PaymentAddMethodContainer;
